import { Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OPCheckBox } from '../../../OPcomponents/OPCheckBox'
import CVCard from './CVCard'
import { useCVSettings } from './CVSettingsContext'

export const CertificatesCard: React.FC = () => {
  const { t } = useTranslation()
  const { state, handleSwitchChange } = useCVSettings()
  const { inc_certificates, inc_certissuer, inc_certvalidity, inc_certdetails, inc_certshowexpired } = state

  return (
    <CVCard
      title={t('CVTemplates.Certificates')}
      description={t('CVTemplates.ProfessionalCertificatesAndQualifications')}
      isEnabled={inc_certificates}
      toggleName='inc_certificates'
      onToggleChange={handleSwitchChange}
    >
      <Grid item>
        <OPCheckBox
          name='inc_certissuer'
          label={t('CVTemplates.ShowCertificateIssuer')}
          value={inc_certissuer}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_certvalidity'
          label={t('CVTemplates.ShowValidity')}
          value={inc_certvalidity}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_certdetails'
          label={t('CVTemplates.ShowCertificateDetails')}
          value={inc_certdetails}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_certshowexpired'
          label={t('CVTemplates.ShowExpired')}
          value={inc_certshowexpired}
          onChangeState={handleSwitchChange}
        />
      </Grid>
    </CVCard>
  )
}
